import React from 'react';
import * as Styled from './SelectCarousel.styled';
/**
 * Component that renders a controller to navigate the Carousel
 */
var SelectCarousel = function (_a) {
    var className = _a.className, _b = _a.withNumbers, withNumbers = _b === void 0 ? true : _b, currentSlide = _a.currentSlide, totalSlides = _a.totalSlides, onInfiniteLoop = _a.onInfiniteLoop, onLeftArrowClick = _a.onLeftArrowClick, onRightArrowClick = _a.onRightArrowClick, _c = _a.size, size = _c === void 0 ? 'large' : _c;
    return (React.createElement(Styled.SelectCarousel, { className: className, withNumbers: withNumbers },
        React.createElement(Styled.ButtonIcon, { variant: "secondary", isGhost: true, name: "arrow-left", "aria-label": "arrow-left", iconSize: size === 'large' ? 24 : 16, isRounded: false, isDisabled: !onInfiniteLoop && currentSlide === 1, onClick: function () {
                if (currentSlide === 1 && onInfiniteLoop) {
                    onInfiniteLoop('previous');
                }
                else {
                    onLeftArrowClick();
                }
            } }),
        withNumbers && (React.createElement(Styled.NumberContainer, { size: size },
            React.createElement(Styled.Number, null, currentSlide),
            React.createElement(Styled.Slash, null, " / "),
            React.createElement(Styled.Number, null, totalSlides))),
        React.createElement(Styled.ButtonIcon, { variant: "secondary", isGhost: true, name: "arrow-right", "aria-label": "arrow-right", iconSize: size === 'large' ? 24 : 16, isRounded: false, isDisabled: !onInfiniteLoop && currentSlide === totalSlides, size: size, onClick: function () {
                if (currentSlide === totalSlides && onInfiniteLoop) {
                    onInfiniteLoop('next');
                }
                else {
                    onRightArrowClick();
                }
            } })));
};
export default SelectCarousel;
